import { getProductWithVariants, ProductWithVariants } from '@models/product';
import { defaultContractWidgets } from '../../../config/default-contract-widgets';
import { SingleInsurantWidgetComponent } from '../../../customer-portal/widgets/single-insurant-widget/single-insurant-widget.component';
import { MusikinstrumenteSchulenWidgetKlasseComponent } from '../widgets/musikinstrumente-schulen-klasse-widget/musikinstrumente-schulen-klasse-widget.component';
import { MusikinstrumenteSchulenWidgetPoolComponent } from '../widgets/musikinstrumente-schulen-pool-widget/musikinstrumente-schulen-pool-widget.component';
import { OrderState } from 'app/order/models';
import { hasTag } from 'app/products/fns';

export const musicInstrumentInsuranceForSchools: ProductWithVariants = getProductWithVariants({
    slug: 'musikinstrumentenversicherung-schulen-p',
    title: 'Musikinstrumentenversicherung für Schulen',
    fullTitle: 'Musikinstrumentenversicherung für Schulen',
    collapsableTitle: 'Musikinstrumenten&shy;versicherung für Schulen',
    insuranceTypeName: 'Musik Instrumente',
    insuranceTypeId: 20,
    legacy: true,
    portalConfig: {
        icon: 'music_school',
        widgets: [
            ...defaultContractWidgets,
            { component: SingleInsurantWidgetComponent },
            { component: MusikinstrumenteSchulenWidgetPoolComponent },
        ],
    },
    variants: [
        {
            condition: (state: OrderState) => hasTag(state, 'isContractPerPupil', true),
            overrides: {
                slug: 'musikinstrumentenversicherung-schulen-k',
                insuranceTypeName: 'Musik Klasse',
                insuranceTypeId: 21,
                portalConfig: {
                    widgets: [
                        ...defaultContractWidgets,
                        { component: SingleInsurantWidgetComponent },
                        { component: MusikinstrumenteSchulenWidgetKlasseComponent },
                    ],
                },
            },
        },
    ],
    onInit: (state) => ({ ...state, insuredObjects: [] }),
});
